// VanJS Feather - Pocket
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Pocket = (props: Partial<SVGProps> = {}) => {
  const { path, polyline } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    path({
      "d":
        "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
    }),
    polyline({ points: "8 10 12 14 16 10" }),
  );
};
